// NotificationBanner.tsx
import React, { forwardRef } from 'react';

export interface IBannerProps {
  showBanner: boolean;
  message: string | React.ReactNode;
  background: string;
  color?: string;
  type?: 'photo' | 'ac' | 'pending';
  isMobile?: boolean;

  // visibility flags (optional)
  isPhotoVisible?: boolean;
  isCandidateVisible?: boolean;
  isPendingVisible?: boolean;
}

export const NotificationBanner = forwardRef<HTMLDivElement, IBannerProps>(
  (
    {
      showBanner,
      message,
      background,
      color,
    }: IBannerProps,
    ref
  ) => {
    if (!showBanner) return null;

    return (
      <div
        ref={ref}
        className="notification-banner cco_row"
        style={{ marginBottom: 10, boxSizing: 'border-box' }}
      >
        <div className="cco_col">
          <div
            className={`cco_text cco_text_${background}`}
            style={{ color: color || '' }}
          >
            <div className="cco_text_inner">
              <p style={{ margin: 0 }}>{message}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

NotificationBanner.displayName = 'NotificationBanner';
